// extracted by mini-css-extract-plugin
export default {"recoverContainer":"verify-authenticator_recoverContainer__fssoV"};